import 'react-multi-carousel/lib/styles.css';
import React from 'react';
import Carousel, { ResponsiveType } from 'react-multi-carousel';
import { SM_BREAKPOINT, MD_BREAKPOINT } from '@/lib/constants';
import { Navigation } from './Navigation';

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1700 },
    items: 3,
    slidesToSlide: 1, // optional, default to 1.
    partialVisibilityGutter: 30,
  },
  desktop: {
    breakpoint: { max: 1700, min: MD_BREAKPOINT },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: { max: MD_BREAKPOINT, min: SM_BREAKPOINT },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
    partialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: { max: SM_BREAKPOINT, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
    partialVisibilityGutter: 25,
  },
};

interface CarouselReactMultiProps {
  children: React.ReactNode;
  responsiveObject?: ResponsiveType;
}

const CarouselReactMulti = ({ children, responsiveObject }: CarouselReactMultiProps) => {
  return (
    <Carousel
      responsive={responsiveObject ?? responsive}
      customButtonGroup={<Navigation items={8} offset={2} />}
      renderButtonGroupOutside={true}
      ssr={false}
      infinite={true} // this will change how the index is calculated
      autoPlay={true}
      autoPlaySpeed={4000}
      centerMode={false}
      keyBoardControl={false}
      arrows={false}
      partialVisible={true}
      pauseOnHover={true}
      itemClass="pl-4 md:pl-6 lg:pl-6 xl:pl-6"
    >
      {children}
    </Carousel>
  );
};

export default CarouselReactMulti;
